import styled from 'styled-components';
import { COLORS } from '@/constants';
import { Button } from '@mui/material';

export const NotFoundContainer = styled.div`
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 60px 0;
  padding-bottom: 150px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  position: relative;
  z-index: 1;
`;

export const NotFoundHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  text-align: center;
  max-width: 700px;
  padding: 0px 24px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  svg {
    min-width: fit-content;
  }
`;

export const NotFoundHeaderBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${COLORS.blue};
  align-items: flex-start;
  text-align: start;
`;

export const IconWrapper = styled.div`
  width: 120px;
  height: 120px;
  min-width: 120px;
  background-color: #e8e8e8;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
    min-width: 80px;
  }
`;

export const SearchSection = styled.div<{ $styles?: string }>`
  margin: 0 auto;
  padding: 0px 24px;
`;

export const RecommendationsSection = styled.div`
  position: relative;
  padding: 0px 24px;
`;

export const CarouselContainer = styled.div`
  margin: 0 auto;
  max-width: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
  height: fit-content;
  z-index: 10;
  position: relative;

  .swiper {
    width: 100%;
    max-width: 1200px;
    height: fit-content;
    margin: 0;
  }

  .mySwiper {
    width: 100%;
    @media (max-width: 1024px) {
      overflow: visible;
    }
  }

  .swiper-slide {
    background-color: transparent !important;
    height: auto;
  }
`;

export const StyledButton = styled(Button)`
  width: 54px;
  height: 54px;
  min-height: 54px;
  min-width: 54px !important;
  max-width: 54px;
  max-height: 54px;
  color: ${COLORS.orange} !important;
  border-color: ${COLORS['blue-light-2']} !important;
  background: ${COLORS.white} !important;
  border: 2px solid ${COLORS['blue-light-2']} !important;
  border-radius: 50% !important;
  padding: 14px !important;
  box-shadow: 0px 5px 8px 0px #391f151a;

  &:disabled {
    opacity: 0.4;
  }

  @media (max-width: 1024px) {
    display: none !important;
  }
`;

export const NotFoundBgLeft = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 0;
`;

export const NotFoundBgRight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  top: 36px;
  pointer-events: none;
  z-index: 0;
`;

export const BottomLeftBlock = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;

  // @media (max-width: 768px) {
  //   display: none;
  // }
`;

export const RightCenterBlock = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;
